$(document).ready(function () {


    document.querySelectorAll('[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });

});

 $(document).on("click", ".hk-play-button", function (e) {
     var video = jQuery(this).parents('.hk-video-wrapper').find('video');
 if (jQuery(this).hasClass("hk-active")) {
    jQuery(this).parents('.hk-video-wrapper').removeClass('hk-active');
     jQuery(this).removeClass('hk-active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.hk-video-wrapper').addClass('hk-active');
     jQuery(this).addClass('hk-active');
 }
 });



 
jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

$(window).on('scroll', function () {
  let scrollTop = $(this).scrollTop();

  if (scrollTop > 30) {
    $('body').addClass('remove_transparent');
  } else {
    $('body').removeClass('remove_transparent');
  }
});



$(document).on("click", ".hk-question", function (e) {
  if (jQuery(this).hasClass("hk-active")) {
    jQuery(this).toggleClass('hk-active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.hk-question').removeClass('hk-active');
    jQuery('.hk-question').next().slideUp();
    jQuery(this).toggleClass('hk-active');
    jQuery(this).next().slideToggle();
  }
});

$(document).on("click", "a[href='#']", function (e) {
e.preventDefault();
});

$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", ".hk-mobile-menu-button", function (e) {
    $('.hk-drawer-menu').addClass('active');
    $('.hk-drawer-menu-bg').show();
    $('body').addClass('hk-overflow-hidden');
});
$(document).on("click", ".hk-mobile-menu-close", function (e) {
    $('.hk-drawer-menu').removeClass('active');
    $('.hk-drawer-menu-bg').hide();
    $('body').removeClass('hk-overflow-hidden');
});

$(document).on("click", ".hk-drawer-menu-bg", function (e) {
    $('.hk-drawer-menu').removeClass('active');
    $('.hk-drawer-menu-bg').hide();
    $('body').removeClass('hk-overflow-hidden');
});


$(document).on('click', '.hk-element-sub-option.hk-active', function () {
$('.hk-element-sub-option:not(.hk-active)').trigger('click');
});

$(document).on('click', '.hk-element-sub-option:not(.hk-active)', function () {
  var $this = $(this);
  var tab = parseInt($this.attr('sub_tab'), 10); // 1,2,3...
  var selling_plan = parseInt($('.hk-element-option.hk-active').attr('selling_plan'), 10); // 1,2,3...
  if (!tab) return;
  $('.hk-element-sub-option').removeClass('hk-active');
  $this.addClass('hk-active');
$('.hk-sub-trigger').hide().removeClass('hk-active');
$('.hk-sub-trigger[sub_tab="'+tab+'"]').show().addClass('hk-active');
if (tab == 1){
$('.hk-checkout-button').attr('selling_plan',selling_plan);
} else {
$('.hk-checkout-button').removeAttr('selling_plan');
}
});



$(document).on('click', '.hk-element-option', function () {
  var $this = $(this);
  var tab = parseInt($this.attr('data_tab'), 10); // 1,2,3...
  var quantity = parseInt($(this).attr('quantity'), 10); // 1,2,3...

  if (!tab) return;

  // Remove active from siblings
  $('.hk-element-option').removeClass('hk-active');

  // Add active to current
  $this.addClass('hk-active');

$('.hk-quantity-trigger').hide().removeClass('hk-active');
$('.hk-quantity-trigger[data_tab="'+tab+'"]').show().addClass('hk-active');
$('.hk-checkout-button').attr('quantity',quantity);
});






$(document).on("click", ".hk-tab", function (e) {
  var index = parseInt($(this).index())+1;
   $('.hk-tab').removeClass('hk-active');
   $(this).addClass('hk-active');
   $('.hk-tab-grid').removeClass('hk-active');
   $('.hk-tab-grid'+index).addClass('hk-active');
});






$(document).on("click", ".hk-cart-button", function (e) {
   openCartDrawer();
});



$(document).on("click", "#CartDrawer-Overlay", function (e) {
   closeCartDrawer();
});


$(document).on("click", ".hk-clinical a, .hk-pdp-sold-out .hk-element-text", function (e) {
  e.preventDefault();
  window.openScienceModal();
});



$(document).on("click", ".hk-parent-link>.hk-parent-item", function (e) {
if (window.innerWidth <= 915) {
  if (jQuery(this).hasClass("hk-active")) {
    jQuery(this).toggleClass('hk-active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.hk-parent-link>.hk-parent-item').removeClass('hk-active');
    jQuery('.hk-parent-link>.hk-parent-item').next().slideUp();
    jQuery(this).toggleClass('hk-active');
    jQuery(this).next().slideToggle();
  }
}
});

function closeCartDrawer() {
  const drawer = document.querySelector('cart-drawer');

  if (!drawer) return;

  drawer.classList.remove('active');
  document.body.classList.remove('overflow-hidden');
}


function openCartDrawer() {
  const drawer = document.querySelector('cart-drawer');

  if (!drawer) return;

  drawer.classList.add('active');
  document.body.classList.add('overflow-hidden');
}

async function refreshCartDrawer() {
  try {
    const response = await fetch('/?sections=cart-drawer');
    const data = await response.json();

    const newDrawer = new DOMParser()
      .parseFromString(data['cart-drawer'], 'text/html')
      .querySelector('cart-drawer');

    const currentDrawer = document.querySelector('cart-drawer');

    if (newDrawer && currentDrawer) {
      currentDrawer.innerHTML = newDrawer.innerHTML;
      currentDrawer.classList.remove('is-empty');
    }

    openCartDrawer();
  } catch (error) {
    console.error('Failed to refresh cart drawer:', error);
    openCartDrawer();
  }
}



$(document).on('click', '.hk-atc-js', async function (e) {
    e.preventDefault();

    var $btn = $(this);

    // Prevent multiple clicks
    if ($btn.hasClass('hk-loading')) return;

    $btn.addClass('hk-loading');

    var variantId = $btn.attr('variant_id');
    var quantity = parseInt($btn.attr('quantity'), 10) || 1;

    if (!variantId) {
        $btn.removeClass('hk-loading');
        return;
    }

    try {
        await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                items: [
                    {
                        id: variantId,
                        quantity: quantity
                    }
                ]
            })
        });

        await refreshCartDrawer();
        await updateCartCount();
    } catch (error) {
        console.error(error);
    } finally {
        $btn.removeClass('hk-loading');
    }
});


async function updateCartCount() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    document.querySelectorAll('.hk-cart-count').forEach((count) => {
      count.textContent = cart.item_count;
      count.style.display = cart.item_count > 0 ? '' : 'none';
    });
  } catch (error) {
    console.error('Failed to update cart count:', error);
  }
}

/* ============================================================
   Keep the header cart count in sync with EVERY cart mutation,
   whoever triggered it (theme form, hk-atc-js, cart drawer,
   quantity steppers, apps).
   ============================================================ */
(() => {
  const CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?/;

  let pending = null;
  const scheduleCartCount = () => {
    clearTimeout(pending);
    pending = setTimeout(() => {
      if (typeof updateCartCount === 'function') updateCartCount();
    }, 120);
  };

  // --- fetch ---
  const origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (...args) {
      const input = args[0];
      const url = (input && input.url) ? input.url : String(input || '');
      return origFetch.apply(this, args).then((res) => {
        if (CART_MUTATION.test(url)) scheduleCartCount();
        return res;
      });
    };
  }

  // --- XMLHttpRequest (older themes / some apps) ---
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__hkCartUrl = url;
    return origOpen.call(this, method, url, ...rest);
  };

  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener('load', () => {
      if (CART_MUTATION.test(String(this.__hkCartUrl || ''))) scheduleCartCount();
    });
    return origSend.apply(this, args);
  };

  // --- Theme / app events ---
  ['cart:updated', 'cart:refresh', 'cart:build', 'ajaxProduct:added', 'cart-drawer:open']
    .forEach((evt) => document.addEventListener(evt, scheduleCartCount));

  // Initial paint + back/forward cache restore
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleCartCount, { once: true });
  } else {
    scheduleCartCount();
  }
  window.addEventListener('pageshow', scheduleCartCount);
})();